/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
import { Redirect, Route } from "react-router-dom";

import {
  Sidebar,
  ISidebarProps,
  Topbar,
  ITopbarProps,
  Footer,
  IFooterProps,
} from "./components";

export interface IRouteProps {
  component: any;
  notFoundLink?: string;
  abilityCheck?(): boolean;
  [key: string]: any;
}

export const RouteWithSidebar = ({
  component: Component,
  notFoundLink,
  abilityCheck,
  ...rest
}: IRouteProps & ISidebarProps & ITopbarProps & IFooterProps) => {
  const resize = () => {
    var resize = setInterval(() => {
      window.dispatchEvent(new Event("resize"));
    }, 10);
    setTimeout(function () {
      clearInterval(resize);
    }, 301);
  };

  const localStorageIsContracted = () => {
    const isContracted = localStorage.getItem("sidebarContracted");
    if (isContracted === null) {
      return false;
    } else {
      return isContracted !== "false";
    }
  };

  const [contracted, setContracted] = useState(localStorageIsContracted());
  const [contractSidebar, setContractSidebar] = useState(
    localStorageIsContracted(),
  );

  const toggleMouseOver = () => {
    if (contracted) {
      setContractSidebar(!contractSidebar);
    }
    resize();
  };

  const toggleContracted = () => {
    setContracted(!contracted);
    setContractSidebar(!contracted);
    localStorage.setItem("sidebarContracted", !contracted);
    resize();
  };

  const _renderMainComp = () => {
    return (
      <Route
        {...rest}
        render={(props) => (
          <>
            <Sidebar
              contracted={contractSidebar}
              onMouseEnter={toggleMouseOver}
              onMouseLeave={toggleMouseOver}
              {...rest}
            />

            <main className="content">
              <Topbar toggleContracted={toggleContracted} {...rest} />
              <Component {...props} />
              <Footer
                {...rest}
                isFixed={props.location.pathname !== "/band-route-live-map"}
              />{" "}
            </main>
          </>
        )}
      />
    );
  };

  if (abilityCheck) {
    const canRender = abilityCheck();
    if (canRender) {
      return _renderMainComp();
    }
    if (notFoundLink) {
      return <Redirect to={notFoundLink} />;
    }
    return null;
  }
  return _renderMainComp();
};

RouteWithSidebar.defaultProps = {};

export { Sidebar, ISidebarProps, Topbar, ITopbarProps, Footer, IFooterProps };
